import { makeQueryKeys } from '@/lib/query-keys';

const _videoKeys = makeQueryKeys('video');

/**
 * Query keys for the video module.
 * - `callStatus(sessionId)` is the canonical key for
 *   `GET /sessions/:sessionId/call/status`. All consumers must use this
 *   accessor — never reconstruct the literal. Find consumers with:
 *   `git grep videoKeys.callStatus`.
 */
export const videoKeys = {
  ..._videoKeys,
  callStatus: (sessionId: string): readonly ['video', 'call-status', string] =>
    ['video', 'call-status', sessionId] as const,
} as const;
